import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div data-testid="page-404" className="bg-[#F9F8F6] min-h-[80vh] flex items-center">
      <div className="container-editorial">
        <div className="text-[10px] uppercase tracking-[0.32em] text-[#7A736C] mb-6">404</div>
        <h1 className="font-serif text-6xl md:text-8xl tracking-tight leading-[1]">The page you're looking for has moved.</h1>
        <p className="mt-8 max-w-xl text-[#4A4642]">You've followed a link that no longer leads anywhere. Return home, or browse our recent work.</p>
        <div className="mt-10 flex gap-4">
          <Link to="/" className="px-8 py-4 bg-[#2B2927] text-[#F9F8F6] text-xs uppercase tracking-[0.24em] rounded-sm hover:bg-[#A85C42] transition-colors">Home</Link>
          <Link to="/portfolio" className="px-8 py-4 border border-[#2B2927] text-[#2B2927] text-xs uppercase tracking-[0.24em] rounded-sm hover:bg-[#2B2927] hover:text-[#F9F8F6] transition-colors">Projects</Link>
        </div>
      </div>
    </div>
  );
}
